// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34-Bz","label":"styles_label__1vqZR"};